import { render } from "./reportView.vue?vue&type=template&id=295a654d"
import script from "./reportView.vue?vue&type=script&lang=js"
export * from "./reportView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__